// Display masking for blocked managers.
//
// Blocking is a display-level mask, not a removal. A league is a fixed set of
// managers who drafted teams and score points against each other every week;
// dropping one out of the standings because a single member blocked them would
// corrupt the table for everyone, and would let a block be used as a weapon.
// So the blocked manager keeps their row, their rank and their points, and
// everything they authored (team name, avatar, smack talk) is replaced.

export const BLOCKED_TEAM_NAME = "Blocked manager";

/**
 * Replaces the user-authored fields on a member row when the viewer has
 * blocked them. Returns the row unchanged otherwise, so callers can map over
 * every member without branching.
 *
 * `blockedIds` is a Set of users.id values, not league_members.id: a block
 * follows the person across every league they share with the blocker.
 */
export function maskBlockedMember(member, blockedIds) {
  if (!member || !blockedIds?.has(member.user_id)) return member;
  return {
    ...member,
    blocked: true,
    team_name: BLOCKED_TEAM_NAME,
    teamName: BLOCKED_TEAM_NAME,
    avatar_url: null,
    smack_talk: null,
    // The real name is as much user-authored content as the team name is, and
    // the pages that fall back to it when team_name is empty would otherwise
    // print it straight through the mask.
    first_name: BLOCKED_TEAM_NAME,
    last_name: "",
  };
}

export function maskBlockedMembers(members, blockedIds) {
  if (!blockedIds?.size) return members;
  return (members || []).map((m) => maskBlockedMember(m, blockedIds));
}
